import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_DISNEY_PLUS_DETAILS = 'GET_DISNEY_PLUS_DETAILS';
export const GET_DISNEY_PLUS_DETAILS_SUCCESS =
  'GET_DISNEY_PLUS_DETAILS_SUCCESS';
export const GET_DISNEY_PLUS_DETAILS_FAILED = 'GET_DISNEY_PLUS_DETAILS_FAILED';

export class GetDisneyPlusDetails implements Action {
  type = GET_DISNEY_PLUS_DETAILS;

  constructor(public payload: any) {}
}

export class GetDisneyPlusDetailsSuccess implements Action {
  type = GET_DISNEY_PLUS_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetDisneyPlusDetailsFailed implements Action {
  type = GET_DISNEY_PLUS_DETAILS_FAILED;

  constructor(public payload: TechnicalError) {}
}
